import { INVALID_TASK_DEPENDENCIES } from './taskErrors';
import { err, ok } from './utils';
import type { TaskDependenciesById } from '../graph/graphSlice';
import { TaskDependencyError } from '../selectors';
import {
  MaybeWorkflowSerializationErrors,
  WorkflowSerializationError,
} from '../shared/types';

export type TaskDependenciesByTaskId = {
  [taskId: string]: string[];
};

export const _taskDependenciesToInput = (
  taskDependencies: TaskDependenciesById
): TaskDependenciesByTaskId => {
  return Object.values(taskDependencies).reduce<TaskDependenciesByTaskId>(
    (previous, tdVal) => {
      const previousDependencies = previous[tdVal.toTaskId] ?? [];

      return {
        ...previous,
        [tdVal.toTaskId]: [...previousDependencies, tdVal.fromTaskId],
      };
    },
    {}
  );
};

export const getJsonTaskDependencies = (
  taskDependencies: TaskDependenciesById,
  taskDependenciesErrors: Record<string, TaskDependencyError[]> | null
): MaybeWorkflowSerializationErrors<TaskDependenciesByTaskId> => {
  const data: TaskDependenciesByTaskId =
    _taskDependenciesToInput(taskDependencies);

  if (!taskDependenciesErrors) {
    return ok(data);
  }
  const errors: WorkflowSerializationError[] = Object.entries(
    taskDependenciesErrors
  )
    .filter(
      ([tdId, tdErrors]) =>
        Object.keys(taskDependencies).some((tdKey) => tdKey === tdId) &&
        tdErrors.length > 0
    )
    .map(
      (): WorkflowSerializationError => ({
        errorType: 'taskDependencies',
        message: INVALID_TASK_DEPENDENCIES,
      })
    );

  return errors.length > 0 ? err(errors) : ok(data);
};

export const getJsonTaskDependenciesForSave = (
  taskDependencies: TaskDependenciesById,
  taskDependenciesErrors: Record<string, TaskDependencyError[]> | null
): TaskDependenciesByTaskId => {
  return Object.entries(taskDependencies).reduce<TaskDependenciesByTaskId>(
    (previous, [key, val]) => {
      if (taskDependenciesErrors && taskDependenciesErrors[key]?.length) {
        return previous;
      }

      const previousDependencies = previous[val.toTaskId] ?? [];

      return {
        ...previous,
        [val.toTaskId]: [...previousDependencies, val.fromTaskId],
      };
    },
    {}
  );
};
